import React from 'react';
import styled from 'styled-components';
import InputMask from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { inputStyle } from './Input';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const ErrorText = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.colors.error};
`;

const StyledInput = styled(InputMask)`
  ${inputStyle}
  height: 33px;
`;

const StyledInputHollow = styled(InputMask)`
  ${inputStyle};
  height: 26px;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.darkGrey};
  ${(props) =>
    props.error &&
    `
        border-color: ${props.theme.colors.error}
    `}
`;

export const CurrencyInput = ({ value, onChange, error, variant, ...rest }) => {
  const currencyMask = createNumberMask({
    prefix: 'R$ ',
    includeThousandsSeparator: false,
    allowDecimal: true,
    decimalSymbol: ','
  });

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const InputComponent = variant === 'hollow' ? StyledInputHollow : StyledInput;

  return (
    <Wrapper>
      <InputComponent
        mask={currencyMask}
        value={value}
        onChange={handleChange}
        error={error}
        {...rest}
      />
      <ErrorText>{error || ''}</ErrorText>
    </Wrapper>
  );
};
